const extend = (...objs) => Object.assign({}, ...objs);

export default extend;
